import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LandingPage from "./LandingPage/Pages";
import ProductDetail from "./LandingPage/Pages/produk/detailProdukPage";
import Checkout from "./LandingPage/Pages/checkout/checkoutPages";
import Login from "./LandingPage/Pages/authAdmin/login";
import RouteGuard from "./utils/RouteGuard";
import DashboardLayout from "./LandingPage/Pages/dashboard/page-dashboard";
import Beranda from "./LandingPage/Pages/dashboard/beranda/beranda";
import Produk from "./LandingPage/Pages/dashboard/produk/produk";
import TambahProduk from "./LandingPage/Pages/dashboard/produk/tambah-produk";
import ProdukDetail from "./LandingPage/Pages/dashboard/produk/detail-produk";
import TambahKategori from "./LandingPage/Pages/dashboard/produk/tambahkategori";
import UserPengguna from "./LandingPage/Pages/dashboard/beranda/TableDetailBeranda/userAll";
import Orders from "./LandingPage/Pages/dashboard/order/order";
import ProductGrid from "./LandingPage/Pages/produk/produkPages";
import About from "./LandingPage/Pages/tentang/tentang";
import FAQ from "./LandingPage/Pages/faq/faq";
import UsersAdminPage from "./LandingPage/Pages/dashboard/akunAdmin/akunAdminPage";
import TambahAdminPage from "./LandingPage/Pages/dashboard/akunAdmin/tambahAdmin";
import AffiliateRegister from "./LandingPage/Pages/authAffiliate/PageRegisAffiliate";
import LoginAffiliate from "./LandingPage/Pages/authAffiliate/loginAffiliate";
import UsersAffiliatePage from "./LandingPage/Pages/dashboard/akunAffiliate/akunAffiliate";
import PenjualanAffiliatePage from "./LandingPage/Pages/dashboard/akunAffiliate/penjualanAffiliate";
import AffiliateCommissionPage from "./LandingPage/Pages/dashboard/akunAffiliate/setKomisi";
import DetailPenjualanAffiliatePage from "./LandingPage/Pages/dashboard/akunAffiliate/detailPenjualanAffiliate";
import DashboardAffiliateLayout from "./LandingPage/Pages/dashboardAffiliate/pageDashboardAffiliate";
import BerandaAffiliate from "./LandingPage/Pages/dashboardAffiliate/beranda/beranda";
import OrdersAffiliate from "./LandingPage/Pages/dashboardAffiliate/orderAffiliate/orderAffiliate";
import ProdukAffiliate from "./LandingPage/Pages/dashboardAffiliate/produkAffiliate/produkAffiliate";
import WithdrawAffiliate from "./LandingPage/Pages/dashboardAffiliate/wdAffiliate/wdAffiliate";
import TambahWithdrawAffiliatePage from "./LandingPage/Pages/dashboardAffiliate/wdAffiliate/tambahWd";
import WdAdmin from "./LandingPage/Pages/dashboard/wdAdmin/wdAdmin";
import AkunAffiliate from "./LandingPage/Pages/dashboardAffiliate/akunAffiliate/akunAffiliate";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/login/admin" element={<Login />} />
        <Route path="/login/affiliate" element={<LoginAffiliate />} />
        <Route path="/register/affiliate" element={<AffiliateRegister />} />
        <Route path="/" element={<LandingPage />} />
        <Route path="/produk" element={<ProductGrid />} />
        <Route path="/tentang" element={<About />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/produk/:id" element={<ProductDetail />} />
        <Route path="/checkout" element={<Checkout />} />

        <Route
          path="/dashboard"
          element={
            <RouteGuard>
              <DashboardLayout />
            </RouteGuard>
          }>
          <Route path="/dashboard/beranda" element={<Beranda />} />
          <Route path="/dashboard/produk" element={<Produk />} />
          <Route path="/dashboard/produk/tambah" element={<TambahProduk />} />
          <Route path="/dashboard/produk/:id" element={<ProdukDetail />} />
          <Route path="/dashboard/kategori/tambah" element={<TambahKategori />} />
          <Route path="/dashboard/order" element={<Orders />} />
          <Route path="/dashboard/admin" element={<UsersAdminPage />} />
          <Route path="/dashboard/admin/tambah" element={<TambahAdminPage />} />
          <Route path="/dashboard/affiliate/akun" element={<UsersAffiliatePage />} />
          <Route path="/dashboard/affiliate/penjualan" element={<PenjualanAffiliatePage />} />
          <Route path="/dashboard/affiliate/penjualan/detail/:id" element={<DetailPenjualanAffiliatePage />} />
          <Route path="/dashboard/affiliate/setkomisi" element={<AffiliateCommissionPage />} />
          <Route path="/dashboard/withdraw" element={<WdAdmin />} />

          {/* AKUN */}
          <Route path="/dashboard/pengguna" element={<UserPengguna />} />
        </Route>

        <Route
          path="/dashboard-affiliate"
          element={
            <RouteGuard>
              <DashboardAffiliateLayout />
            </RouteGuard>
          }>
          <Route path="/dashboard-affiliate/beranda" element={<BerandaAffiliate />} />
          <Route path="/dashboard-affiliate/order" element={<OrdersAffiliate />} />
          <Route path="/dashboard-affiliate/produk" element={<ProdukAffiliate />} />
          <Route path="/dashboard-affiliate/withdraw" element={<WithdrawAffiliate />} />
          <Route path="/dashboard-affiliate/withdraw/tambah" element={<TambahWithdrawAffiliatePage />} />
          <Route path="/dashboard-affiliate/akun" element={<AkunAffiliate />} />
        </Route>
      </Routes>
    </Router>
  );
};

export default App;
